package com.example.mystybag.sharedmodels.project.responseModels.merchant

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import kotlinx.serialization.Serializable

@Serializable
class GetStripeOnboardingLinkResponseModel(
    val onboardingUrl: String = "",
    // Unix timestamp (seconds) when the link expires
    val expiresAt: Long = 0L
) : BaseResponseModel()
